module.exports = __webpack_public_path__ + "img/7.1d6a9486.jpg";